import { useEffect, useState } from 'react';
import './App.css';
import Login from './components/Login';
import Docs from './components/Docs';
import { parseCollection } from './data/parseCollection';
import { isAuthenticated } from './utils/auth';

function App() {
  const [authed, setAuthed] = useState(isAuthenticated());
  const [catalog, setCatalog] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!authed) return;
    let cancelled = false;

    Promise.all([
      fetch('/collection.json').then((res) => {
        if (!res.ok) throw new Error('Failed to load API collection.');
        return res.json();
      }),
      fetch("/additionalAPI's.json").then((res) => {
        if (!res.ok) throw new Error('Failed to load additional API collection.');
        return res.json();
      }),
    ])
      .then(([collection, additional]) => {
        if (cancelled) return;
        const merged = {
          ...collection,
          item: [...(collection.item ?? []), ...(additional.item ?? [])],
        };
        setCatalog(parseCollection(merged));
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Failed to load API documentation.');
      });

    return () => {
      cancelled = true;
    };
  }, [authed]);

  if (!authed) {
    return <Login onSuccess={() => setAuthed(true)} />;
  }

  if (error) {
    return (
      <div className="app-error">
        <p>{error}</p>
      </div>
    );
  }

  if (!catalog) {
    return (
      <div className="app-loading">
        <div className="spinner" />
        <p>Loading API documentation…</p>
      </div>
    );
  }

  return <Docs catalog={catalog} onLogout={() => setAuthed(false)} />;
}

export default App;
